<div class="popular-experiences-card mb-4 uk-flex uk-flex-wrap" *ngIf="product">
  <div class="left-panel w-55 position-relative">
    <ng-container *ngIf="product.tags">
      <ng-container *ngFor="let tag of product.tags.split(',')">

        <div class="trending bg-womensday" *ngIf="tag == 'Women\'s Day'">
          <img src="assets/images/icons/women-tag.png" alt="">
          <span>Women's Day</span>
        </div>

        <div class="trending bg-newYearTag" *ngIf="tag == 'New Year'">
          <span>New Year’s Bash</span>
        </div>

        <div class="trending bg-red" *ngIf="tag == 'Valentine Special'">
          <img src="assets/images/icons/heart-2.png" alt="">
          <span>Valentine Special</span>
        </div>

        <div class="trending bg-orange" *ngIf="tag == 'Hot Selling'">
          <img src="assets/images/icons/fire.png" alt="">
          <span>Hot Selling</span>
        </div>

        <div class="trending bg-purple" *ngIf="tag == 'Limited Stock'">
          <img src="assets/images/icons/stock.png" alt="">
          <span>{{tag}}</span>
        </div>
      </ng-container>
    </ng-container>

    <div class="image">
      <div class="logo-mob">
        <a [routerLink]="['/' + product.city.name.toLowerCase().toString() + '/' + product.slug]">
        <img src="{{product.merchant?.logo}}" alt="">
      </a>
      </div>
      <a [routerLink]="['/' + product.city.name.toLowerCase().toString() + '/' + product.slug]">
        <img src="{{product.featured_image}}&h=345&w=277&fit=crop" alt="{{product.title}}">
      </a>
    </div>
  </div>
  <div class="details w-45 text-center">
    <div class="brand">
      <div class="logo mb-2">
        <img src="{{product.merchant?.logo}}" alt="">
      </div>
      <div class="brand-name">
        <h5>
          <a [routerLink]="['/' + product.city.name.toLowerCase().toString() + '/' + product.slug]">
            {{product.title}}
          </a>
        </h5>
        <h6>{{product.category_name}}</h6>
        <div class="location">
          <!--<img src="assets/images/icons/location-black.png" alt="">-->
          <i class="fa fa-map-marker"></i>&nbsp;
          <span>{{product.sub_locality?.sub_locality ? product.sub_locality?.sub_locality : product.city?.name}}</span>
        </div>
      </div>
    </div>

    <div class="price">
      <del *ngIf="product.cheapest_standard_deal?.regular_price">
        <i class="fa fa-rupee"></i> {{product.cheapest_standard_deal?.regular_price | currency:'INR':'':'1.0-0'}}
      </del>
      <div class="offer-price">
        <h4><i class="fa fa-rupee"></i> {{product.cheapest_standard_deal?.sale_price | currency:'INR':'':'1.0-0'}}
        </h4>
        <p>onwards</p>
      </div>
    </div>

    <a [routerLink]="['/' + product.city.name.toLowerCase().toString() + '/' + product.slug]"
       class="btn-yellow">BOOK</a>
    <span class="vouchers" *ngIf="product.min_stocked_standard_deal">{{product.min_stocked_standard_deal?.stock}}
      Vouchers Left</span>
    <span class="vouchers" *ngIf="!product.min_stocked_standard_deal">Sold Out</span>
  </div>
</div>
